import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Flex,Skeleton!=!/root/iyiwutrade/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager" */ "/root/iyiwutrade/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyiwutrade/src/app/(main)/(home)/components/adBooth.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyiwutrade/src/app/(main)/(home)/components/banner.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyiwutrade/src/app/(main)/(home)/components/cyd.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyiwutrade/src/app/(main)/(home)/components/featured.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyiwutrade/src/app/(main)/(home)/components/ImageHotspot.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyiwutrade/src/app/(main)/(home)/components/quotations/form.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyiwutrade/src/app/(main)/(home)/components/suppliers.js");
;
import(/* webpackMode: "eager" */ "/root/iyiwutrade/src/app/(main)/(home)/home.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyiwutrade/src/components/DataBoundary/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyiwutrade/src/components/justForYou/index.js");
